module.exports = __webpack_public_path__ + "static/media/menu-white.95c856b4.svg";